import React from 'react';
import shortid from 'shortid';
import isBlank from '../utils/isBlank';
import findData from './findData';
import findDefinition from './findDefinition';
import formatData, { NO_DATA_DEFAULT } from './formatData';

const createComponent = (type, config) => {
  const {
    accessToken,
    definitions,
    displaySchema,
    schema,
    data: payloadData,
    path,
    onError,
    shouldDisplayBlankFields = false,
  } = config;
  const { Component, ownProps } = findDefinition(definitions, schema, type);
  let data;
  let formatted;

  try {
    data = findData(payloadData, path);

    if (!shouldDisplayBlankFields && isBlank(data)) {
      return () => null;
    }

    if (!data && schema.default) {
      data = schema.default;
    } else if (!data && data !== 0 && !schema.default) {
      // don't render the field at all.
      return () => null;
    }

    formatted = formatData(schema, data);
  } catch (error) {
    data = NO_DATA_DEFAULT;
    formatted = NO_DATA_DEFAULT;
    onError(error);
  }

  return ({ children }) => (
    <Component
      accessToken={accessToken}
      key={shortid.generate()}
      displaySchema={displaySchema}
      schema={schema}
      data={formatted}
      type={type}
      path={path}
      ownData={data}
      ownProps={ownProps}
      ownDefinitions={definitions}
    >
      {children}
    </Component>
  );
};

export default createComponent;
